import { AvailableLanguages, LanguageCode } from "@cirrus/core/i18n"
import { ANGOFF_SETTINGS_DEFAULT } from "@cirrus-author/library/constants"

export class CustomerInfo {
	customerName: string = ""
	defaultFormats: LanguageCode = "en-GB"
	defaultLanguage: LanguageCode = "en-GB"
	availableLanguages: AvailableLanguages = {
		"en-GB": "English (UK)"
	}
	version: string = ""
	skinId: string = ""
	skin: Skin = null
	skinValue: any | null = null
	isDebugMode: boolean = true
	exitUrls = new ExitUrls()
	saml = new SamlSettings()
	hideFormExtendedOptions: boolean = false
	enableProctorIoIntegration: boolean = true
	enableLiveProctoring: boolean = false
	enablePlagiarismDetection: boolean = true
	readSpeakerCustomerId: string = ""
	readSpeakerRegion: string = ""
	readSpeakerDocReaderId: string = ""
	readSpeakerLanguageSettings: ReadSpeakerLanguageSettings[] = [new ReadSpeakerLanguageSettings()]
	enableOffice365Integration: boolean = true
	keycode: KeycodeSettings | null = null
	enableVirtualKeyboard: boolean = true
	angoff = new AngoffSettings()
	enableLtiAdvantage: boolean = true
	regionalSettings: RegionalSettings = new RegionalSettings()
	enableDeliveryV2: boolean = false
	enableExamplary: boolean = false
	directAccessEnabled: boolean = false
	insightsEnabled: boolean = false
	enableResultsAllAttemptsMode: boolean = false

	constructor(args?: Partial<CustomerInfo>) {
		for (const argument in args) {
			this[argument] = args[argument]
		}
	}
}

type Skin = any | null

class ExitUrls {
	author: string = ""
	delivery: string = ""
}

class SamlSettings {
	enabled: boolean = false
	ssoMode: SsoMode = SsoMode.Mixed
	idpName: string = ""
}

export enum SsoMode {
	Mixed,
	Automatic,
	Enforced
}

export class ReadSpeakerLanguageSettings {
	cirrusLangKey: LanguageCode = "en-GB"
	readSpeakerLangKey: string = "en_uk"
	voice: string = "Alice"
	image: string = "united-kingdom"
}

class KeycodeSettings {
	requireUsername: boolean = false
}

export class AngoffSettings {
	useAngoff: boolean = false;
	hardLow: number = ANGOFF_SETTINGS_DEFAULT.hardLow
	hardHigh: number = ANGOFF_SETTINGS_DEFAULT.hardHigh
	mediumLow: number = ANGOFF_SETTINGS_DEFAULT.mediumLow
	mediumHigh: number = ANGOFF_SETTINGS_DEFAULT.mediumHigh
	easyLow: number = ANGOFF_SETTINGS_DEFAULT.easyLow
	easyHigh: number = ANGOFF_SETTINGS_DEFAULT.easyHigh
}

export class RegionalSettings {
	lang: LanguageCode = "en-GB"
	reg: string = "Europe"
	zone: string = "Europe/Oslo"
	offset: number = 120
	formats: string = "en-GB"
	stformat: string = "h:mm A"
	ltformat: string = "h:mm:ss A"
}
